import {
  Component,
  computed,
  EventEmitter,
  input,
  Input,
  Output,
  inject,
} from '@angular/core';
import { SecondaryButtonComponent as SecondaryButtonComponent } from '../../../../../shared/components/secondary-button/secondary-button.component';
import { PrimaryButtonComponent as PrimaryButtonComponent } from '../../../../../shared/components/primary-button/primary-button.component';
import { DisplayPricePerUserComponent } from '../display-price-per-user/display-price-per-user.component';
import { TopicAreaSelectComponent } from '../topic-area-select/topic-area-select.component';
import { ProductDataService } from '../../services/product-data.service';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-subscription-plan-card',
  imports: [
    PrimaryButtonComponent,
    SecondaryButtonComponent,
    DisplayPricePerUserComponent,
    TopicAreaSelectComponent,
    TranslocoPipe,
  ],
  templateUrl: './subscription-plan-card.component.html',
})
export class SubscriptionPlanCardComponent {
  protected readonly productDataService = inject(ProductDataService);

  @Input() trialing = false;
  @Input() planTranslationKey: string;
  @Input() disabled: boolean;
  @Input() preselected: boolean;
  readonly selectedTopicAreaIds = input<string[]>([]);
  @Input() subTitle: string;
  @Input() loading: boolean;
  @Input() unitPrice: number;
  @Input() totalPriceWithoutTaxAndDiscount: number;
  @Output() closeDialog: EventEmitter<void> = new EventEmitter<void>();
  @Output() fetchProductDetails: EventEmitter<void> = new EventEmitter<void>();
  @Output() salesButtonClick: EventEmitter<void> = new EventEmitter<void>();
  @Output() selectedTopicAreaIdsChange: EventEmitter<string[]> =
    new EventEmitter<string[]>();

  selectPlanCTA = computed(() => {
    if (
      this.trialing &&
      this.selectedTopicAreaIds().length ===
        this.productDataService.trialingTopicAreaIds().length &&
      this.selectedTopicAreaIds().every((id) =>
        this.productDataService.trialingTopicAreaIds().includes(id),
      )
    ) {
      return 'product.dialog.continueWithCurrentPlanButton';
    }
    return 'product.dialog.selectPlanButton';
  });

  onSelectButtonClick() {
    this.closeDialog.emit();
  }

  onSalesButtonClick() {
    this.salesButtonClick.emit();
  }

  onSelectedTopicAreaIdsChanged(topicAreaIds: string[]) {
    this.selectedTopicAreaIdsChange.emit(topicAreaIds);
    this.fetchProductDetails.emit();
  }
}
